import dictionary from './dictionary'
import option from './option'
import project from './project'

export default {
  dictionary,
  option,
  project
}



// WEBPACK FOOTER //
// ./src/data/PreviewTrip/index.js